<div class="common-section-wrapper theme-app__bg">
  <div class="common-container" [ngClass]="{ 'common-container--color-settings': colorSettingsMode }">
    <h1 class="common-section-title common-section-title--catalog theme-catalog-page__title">
      {{ lg.tracksBlock.heading }}
    </h1>

    <!-- TODO: when deploy to staging/production change (pagesWithFilter="'dev-mode'") to "production-mode" -->
    <bmcore-tracks-block
      [appType]="'PROD-PAGE'"
      [isTracksPage]="true"
      [isShowTracksAllBeatmakers]="false"
      [isBeatmakerPage]="true"
      [pageSize]="20"
      [beatmakerId]="beatmakerId"
      [currentSortById]="currentSortById"
      [pagesWithFilter]="'production-mode'"
    >
    </bmcore-tracks-block>
  </div>
</div>
